// 덴클 케어(분리 환자앱, 2026-10-04 계획_환자앱1차_통합) — 웹이 쓰는 앱 연결 상수 한 곳
// 규칙: 스토어 주소가 비어 있으면 안내 블록·링크를 아예 그리지 않는다(정본 K-2 — 링크 없는 안내 = 허위 안내). 미확인 값을 채워 넣지 않는다.
// 문구 정본: docs/정본_환자앱1차_문서4묶음_2026-10-04.md §9 (K-1 등). 문구 변경 시 법적보안 확인.
// 의료법: 가격·할인·후기·유인 표현 금지 — 사실 안내만.
import { isCareAppStoreLive } from '../utils/features';

export const CARE_APP_NAME = '덴클 케어';

// 스토어 주소 — 출시 후 대표가 확인한 주소만 기입(번들 ID 미확정: com.dentcluster.patient 재사용 또는 com.dentcluster.care, 계획 §4-2)
export const CARE_APP_STORE_URL = '';
export const CARE_PLAY_STORE_URL = '';

export const careStoreLinks = () => [
    CARE_APP_STORE_URL ? { label: 'App Store', href: CARE_APP_STORE_URL } : null,
    CARE_PLAY_STORE_URL ? { label: 'Google Play', href: CARE_PLAY_STORE_URL } : null,
].filter(Boolean);

// 플래그 careAppStoreLive && 주소 1개 이상 — 둘 다 있어야 안내를 보인다
export const isCareStoreReady = (features) => isCareAppStoreLive(features) && careStoreLinks().length > 0;

// ── 정본 v2.2 K-2(2026-10-05 법적보안, 문안: v2.2_K2.md K-2a~j) — 웹 데스크 접수 완료 화면 앱 안내 블록. 종전 K-1 한 줄(walkinCareLine)을 대체.
//   문구 변경 시 법적보안 확인. 치과명이 없으면(서버 조회 실패) `{clinicName}이(가)` → `치과가`, `{clinicName}에` → `치과에`.
//   "장점"·평가어 금지(§7-3), 치과가 권하는 문장 금지(§56) — 제공자는 덴탈클러스터로 명시(K-2b).
export const WALKIN_CARE_TITLE = '보철물 제작을 맡기신 분께 — 덴클 케어 앱 안내';   // K-2a
export const WALKIN_CARE_INTRO = '덴클 케어는 주식회사 덴탈클러스터가 만든 앱입니다. 앱에서는 다음을 볼 수 있습니다.';   // K-2b
export const WALKIN_CARE_CHOICE = '앱 설치와 등록은 선택입니다. 등록하지 않아도 진료는 똑같이 받으실 수 있습니다.';   // K-2g
// K-2h 등록 방법 — 정본 v2.4-5(v2.5 유지) 확정 문장. 조사는 v2.4-5 P2 선택안 '을(를)'(메인 지시 10-05).
//   치과명이 없으면(서버 조회 실패) 정본 v2.4-5 둘째 행 — 따옴표 없이 "이 치과를".
//   법적보안 v2.8-5(10-05): 「치과 찾기」 운영 플래그(isCareSearchLive) 켜짐일 때만 찾기 포함 문장. 꺼짐·조회 실패 = QR 전용 문장(치과명 유무 무관)
//   — 찾기가 꺼져 있는데 [치과 찾기]를 안내하면 사실과 다른 안내. PatientQrLanding.js 와 같은 기준.
export const walkinCareHowto = (clinicName, searchLive = false) => {
    if (searchLive !== true) {
        return '설치 후 로그인하고 앱에서 [치과 QR 찍기]로 데스크의 QR을 한 번 더 찍은 뒤, 이름과 생년월일을 적으면 바로 등록됩니다. 지금 적으신 접수 내용은 앱으로 넘어가지 않습니다.';
    }
    const n = String(clinicName || '').trim();
    const target = n ? `'${n}'을(를)` : '이 치과를';
    return `설치 후 로그인하고 앱에서 [치과 찾기]로 ${target} 찾거나 [치과 QR 찍기]로 데스크의 QR을 한 번 더 찍은 뒤, 이름과 생년월일을 적으면 바로 등록됩니다. 지금 적으신 접수 내용은 앱으로 넘어가지 않습니다.`;
};
// K-2c~f 기능 4줄 — { label, text }: 화면에서 label 만 굵게. label + ' ' + text = 정본 문장 그대로
export const walkinCareFeatures = (clinicName) => {
    const n = String(clinicName || '').trim();
    const ga = n ? `${n}이(가)` : '치과가';
    const e = n ? `${n}에` : '치과에';
    return [
        { label: '제작 과정:', text: `${ga} 제작 의뢰서를 보내면 의뢰 접수 · 디자인 완료 · 치과 도착 날짜가 표시됩니다.` },   // K-2c
        { label: '도착 알림:', text: `보철물이 ${e} 도착하면 알림이 옵니다. 잠금화면에는 "등록한 치과의 새 소식이 있습니다"로만 보입니다.` },   // K-2d
        { label: '전화 걸기:', text: `앱에서 ${e} 바로 전화를 걸 수 있습니다.` },   // K-2e
        { label: '검진 날짜 알림:', text: '직접 정해 둔 날짜에 휴대폰이 알려 줍니다. 날짜는 이 휴대폰에만 저장됩니다.' },   // K-2f
    ];
};

// 기기 판별 — 브라우저 안에서만(UA). 서버 전송·저장 금지(K-2-3 개인정보). iPadOS 13+ 는 Mac UA + 터치로 판별
export const detectCarePlatform = () => {
    try {
        const ua = String((typeof navigator !== 'undefined' && navigator.userAgent) || '');
        if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
        if (/Macintosh/i.test(ua) && typeof navigator !== 'undefined' && navigator.maxTouchPoints > 1) return 'ios';
        if (/Android/i.test(ua)) return 'android';
    } catch (e) {
        console.error('[덴클 케어] 기기 판별 실패(두 버튼으로 표시):', e?.message || e);
    }
    return 'other';
};

// K-2i·K-2j 버튼 구성 — 링크는 스토어 주소 그대로(식별값·utm 붙이지 않음, K-2-2 조건 6).
//   아이폰+App Store 주소 → [앱 받기] 하나 / 안드로이드+Play 주소 → [앱 받기] 하나 /
//   판별 불가(PC 등) → 있는 스토어마다 이름 붙은 버튼. 아이폰·안드로이드인데 그 스토어 주소가 비었으면 buttons=[] → 블록 숨김
//   (그 기기에서 쓸 수 없는 스토어를 보이지 않음). 빈 링크·"준비 중" 버튼 없음(조건 1).
const STORE_NOTE = { 'App Store': '누르면 애플 App Store로 이동합니다.', 'Google Play': '누르면 구글 Google Play로 이동합니다.' };
export const walkinCareButtons = (platform = detectCarePlatform()) => {
    const links = careStoreLinks();
    const pick = platform === 'ios' ? 'App Store' : platform === 'android' ? 'Google Play' : '';
    const mine = pick ? links.find(l => l.label === pick) : null;
    if (mine) return { buttons: [{ href: mine.href, text: '앱 받기' }], note: STORE_NOTE[mine.label] };
    if (pick || links.length === 0) return { buttons: [], note: '' };
    return {
        buttons: links.map(l => ({ href: l.href, text: `앱 받기 (${l.label})` })),
        note: links.length > 1 ? '누르면 각 스토어로 이동합니다.' : STORE_NOTE[links[0].label],
    };
};
